export default {
	tel:'080-2972-8766',
	mail:'haruko.tsubaki.930@gmail.com',
	zipcode:'〒761-0101',
	address1:'香川県高松市春日町984-1',
	address2:'高松大学南東テニスコートの角を東へ入って１軒目',
	info1:'レッスン日は高松大学南東の曲がり角に、目印のノボリと看板を設置しています。',
	info2:'６台分・教室敷地内',
	info3:'ことでんバス 春日川バス停より徒歩１０分',
	info4:'Chiha（谷川 千春）',
	info5:'ご不明点はお電話でお問い合わせください',
}

// 	//	deviceChecker PCSP・UA判定とクラスの付与
// 	const deviceChecker = () => {
// 		var ua = navigator.userAgent.toLowerCase();
// 		var name = "";
// 		// SP判定
// 		var isAndroid      = ua.indexOf('android') !== -1;
// 		if(isAndroid){ name = 'isAndroid'; }

// 		var isWindowsPhone = ua.indexOf('windows phone') !== -1;
// 		if(isWindowsPhone){ name = 'isWindowsPhone'; }
// 		var isBlackBerry   = ua.indexOf('blackberry') !== -1;
// 		if(isBlackBerry){ name = 'isBlackBerry'; }
// 		var isIPhone       = ua.indexOf('iphone') !== -1;
// 		if(isIPhone){ name = 'isIPhone'; }
// 		var isIPad         = ua.indexOf('ipad') !== -1;
// 		if(isIPad){ name = 'isIPad'; }
// 		var isIPod         = ua.indexOf('ipod') !== -1;
// 		if(isIPod){ name = 'isIPod'; }


// 		var isIOS          = (isIPhone || isIPad || isIPod);
// 		if(isIOS){
// 		 var v = (navigator.appVersion).match(/OS (\d+)_(\d+)_?(\d+)?/);
//           var versions = [parseInt(v[1], 10), parseInt(v[2], 10), parseInt(v[3] || 0, 10)];
//           if(versions[0] < 10 && versions[0] > -1){
//           	isLegacy = true;
//           }
// 		}


// 		var isSP  = isAndroid || isIOS || isWindowsPhone || isBlackBerry;
// 		return isSP;

// };
// // 		// スマホORデスクトップ確認
// // export const uachecker = {
// // 		 checkMobile(){
// // 			return isSP;
// // 		},
// // 	 // ブラウザ名を取得
// // 	 getName = function(){
// // 			return name;
// // 		},
// // };


